import script from "./SearchProductsContainer.vue?vue&type=script&setup=true&lang=js"
export * from "./SearchProductsContainer.vue?vue&type=script&setup=true&lang=js"

import "./SearchProductsContainer.vue?vue&type=style&index=0&id=5ae5ab30&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5ae5ab30"]])

export default __exports__